module.exports = "data:text/x-markdown;base64,Q29udHJhY3RzIGNhbiBtYW5pcHVsYXRlIHdpdGggdGhlIGRhdGEgZnJvbSBvdGhlciBjb250cmFjdHMgdGhlIHdheSB0aGV5IHdhbnQuCgpJdCdzIHVuc2FmZSB0byBhcHByb3ZlIHNvbWUgYWN0aW9uIGJ5IGRvdWJsZSBjYWxsaW5nIGV2ZW4gdGhlIHNhbWUgdmlldyBmdW5jdGlvbi4K"


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels/shop_complete.md
// module id = 1406
// module chunks = 0